module.exports = __webpack_public_path__ + "img/GAME_MARBLES1.682fd55e.jpg";